import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function SignActions(props) {
  const { showFolderSelector, onDelete, edit, unpublish } = props;
  const {
    id,
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  if (!id) {
    return null;
  }

  return (
    <div
      data-test="sign-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="Preview Sign">
        <Link
          to={`/player/?sign=${id}`}
          target="_blank"
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/play_no_bg.svg"
            alt="Copy"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </Link>
      </ToolTipIcon>

      {Writer && (
        <ToolTipIcon toolText="Delete Sign">
          <button
            type="button"
            onClick={onDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}

      {Writer && (
        <ToolTipIcon toolText="Move">
          <button
            type="button"
            onClick={showFolderSelector}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/paste_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}

      {Writer && (
        <ToolTipIcon toolText="Edit">
          <button
            data-test="location-copy-setting"
            type="button"
            onClick={edit}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <i aria-label="creator" className="fa !static fa-paint-brush w-[30px] h-[30px]" />
          </button>
        </ToolTipIcon>
      )}

      {Writer && (
        <ToolTipIcon toolText="Unpublish Sign">
          <button
            data-test="location-copy-setting"
            type="button"
            onClick={unpublish}
            className="duration-500 w-[30px] h-[30px] hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            cloud_off
          </button>
        </ToolTipIcon>
      )}
    </div>
  );
}

SignActions.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showFolderSelector: PropTypes.func.isRequired,
  edit: PropTypes.func.isRequired,
  unpublish: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
const mapDispatchToProps = {};
const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(SignActions);
